import React, { Component } from 'react';
import {http, baseURL} from '../misc/http';
import Layout from '../layout/Main';
import Header from '../components/BlogDetil/Header';
import Content from '../components/BlogDetil/Content';
import PostComment from '../components/BlogDetil/PostComment';
import ListComment from '../components/BlogDetil/ListComment';
import history from '../misc/history';

export default class BlogDetil extends Component {
  state={
    blog: {},
    comments: [],
    comment : ''
  }
  componentDidMount = () => {
    const {id} = this.props.match.params;
    this.handleGetById(id);
    this.handleGetComments(id);
  }

  handleGetById = async (id) => {
    let params = {
      method:'GET',
      path:'blog/'+id,
      showMessage: false
    }
    let {data} = await http(params);
    if (data.status === true && data.code === 200) {
      let {blog} = this.state;
      blog = data.data;
      this.setState({blog})
    }
  }

  handleGetComments = async (id) => {
    let params = {
      method:'GET',
      path:'comments?refId='+id,
      showMessage: false
    }
    let {data} = await http(params);
    if (data.status === true && data.code === 200) {
      let {comments} = this.state;
      comments = data.data;
      this.setState({comments})
    }
  }

  handlePostComment = async () => {
    if (localStorage.getItem('kominfo-psre')){
      let comment = {
        refId: this.state.blog._id,
        refType: 'blog',
        comment:this.state.comment
      }
      let params = {
        method:'POST',
        path:'comments',
        showMessage: false,
        data: comment
      }
      let {data} = await http(params);
      if (data.status === true && data.code === 200) {
        let {comments} = this.state;
        comments.unshift(data.data);
        this.setState({comments})
      }
    } else {
      history.push('/login')
    }
  }

  handleOnChange = ({target: {value}}) => {
    this.setState({comment: value})
  }

  render() {
    return (
      <Layout>
        <Header blog={this.state.blog} baseURL={baseURL}/>
        <section class="detail-acara" style={{borderBottom: '1px solid rgba(0,0,0,0.12)', paddingBottom: '100px'}}>
          <div class="container">
            <div className="col-lg-9 col-md-12 col-sm-12 col-12 mx-auto">
              <Content blog={this.state.blog} />
              <PostComment handlePostComment={this.handlePostComment} handleOnChange={this.handleOnChange} comment={this.state.comment}/>
              <ListComment comments={this.state.comments}/>
            </div>
          </div>
        </section>
      </Layout>
    )
  }
}
